import { ReactElement } from 'react';
import { ValueOfKey } from '../../../utils-types';

/** config for names and orders of columns */
export const COACH_LIST_COLUMN = {
  NAME: 'NAME',
  ENTITY: 'ENTITY',
  STATE: 'STATE',
  CITY: 'CITY',
  SETUP_COMMISSION: 'SETUP_COMMISSION',
  RENEW_COMMISSION: 'RENEW_COMMISSION',
  COACH_DESIGNATION: 'COACH_DESIGNATION',
  STATUS: 'STATUS',
  EXTRA_INFO: 'EXTRA_INFO',
} as const;

export type CoachListColumn = ValueOfKey<typeof COACH_LIST_COLUMN>;

export type RenderRowsInfo = Record<CoachListColumn, ReactElement>;

export type ShowRowsConfig = Record<CoachListColumn, boolean>;

export const COACH_LIST_MODE = {
  NUTRITION: 'NUTRITION',
  SCAN_IQ: 'SCAN_IQ',
} as const;

export type CoachListMode = ValueOfKey<typeof COACH_LIST_MODE>;
